function handleCartEvents(event) {
  const iconCount = document.querySelector('a#cart-icon-bubble');
  const item_count = event.type === "OpusCartChange" ? event.detail.item_count : event.detail.cart.item_count;
  if (item_count > 0) {
    if (!document.querySelector('.wt-header__panel__counter')) {
        iconCount.insertAdjacentHTML("beforeend",
      `<span class="wt-header__panel__counter">${item_count}</span>`) ;
    } 
  } 
    
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);